import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import { includes, isEmpty } from 'lodash'
import { autobind } from 'core-decorators'
import ListItem from './list-item'
import preloadRange, { isInRange, propTypes as preloadPropTypes } from 'shared/components/gif-grid/preload-range'
import scrollPosition, * as scrolling from 'shared/components/gif-grid/scroll-position-props-proxy'
import fetchOnScroll, * as fetchScroll from 'shared/components/gif-grid/fetch-on-scroll'
import ContentAvailable from 'shared/components/content-available/flying-dude'
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys'
import { processChannelGifs } from 'shared/util/gif-process'
import css from './list-channel.css'

const { array, bool, func, number } = PropTypes
const { Globals } = global.Giphy
const POLL_GIFS_INTERVAL = 20000
const BASE_TITLE = document.title

const preload = {
        low: -innerWidth * 2,
        high: innerWidth * 2,
    },
    priority = {
        low: -200,
        high: innerWidth + 200,
    }

const newGifsLabel = count => `View ${count} new ${count === 1 ? 'GIF' : 'GIFs'}`

@onlyUpdateForKeys([
    'gifs',
    'newGifs',
    'addedGifsCount',
    'autoPlay',
    'lastPolled',
    'isInPreloadRange',
    'isInPriorityRange',
    'isLive',
    'isFetching',
])
@scrollPosition(window, scrolling.VERTICAL, scrolling.SCROLL_STOP, 0)
@fetchOnScroll(window, fetchScroll.VERTICAL)
@preloadRange(preload, priority)
export default class extends Component {
    static propTypes = {
        gifs: array,
        newGifs: array,
        addedGifIds: array,
        fetchGifs: func,
        checkForNewGifs: func,
        showNewGifs: func,
        lastPolled: number,
        isFetching: bool,
        isOffscreen: bool,
        isLive: bool,
        onSocialClick: func,
        id: number,
        ...preloadPropTypes,
    }
    static defaultProps = {
        isInPreloadRange: [],
        isInPriorityRange: [],
        isLive: false,
        isOffscreen: false,
    }
    newGifInterval = null
    componentDidMount() {
        const { isLive, checkForNewGifs, channelId, fetchGifs } = this.props

        fetchGifs(`/api/v1/channels/${channelId}/gifs/`, processChannelGifs)

        if (isLive) {
            this.newGifInterval = setInterval(checkForNewGifs, POLL_GIFS_INTERVAL)
        }
    }
    componentWillUnmount() {
        if (this.newGifInterval) {
            clearInterval(this.newGifInterval)
        }
    }
    componentDidUpdate() {
        const { newGifs } = this.props

        // update title
        if (document && document.title) {
            document.title = (newGifs.length ? `(${newGifs.length}) ` : '') + BASE_TITLE
        }

        if (Globals) Globals.refresh()
        super.componentDidUpdate && super.componentDidUpdate()
    }
    @autobind
    getElements() {
        return this.list.getElementsByTagName('li')
    }
    render() {
        const {
            autoPlay,
            gifs,
            newGifs,
            addedGifIds,
            lastPolled,
            isInPriorityRange,
            isInPreloadRange,
            isFetching,
            isLive,
            showNewGifs,
            onSocialClick,
        } = this.props

        return (
            <div>
                <ContentAvailable
                    isActive={!isEmpty(newGifs)}
                    label={newGifsLabel(newGifs.length)}
                    onClick={showNewGifs}
                    isMobile={false}
                />
                <ul className={css.container} ref={c => (this.list = c)}>
                    {gifs.map((gif, index) => (
                        <ListItem
                            gif={gif}
                            key={gif.id}
                            lastTimeChange={lastPolled}
                            isInPriorityRange={isInRange(index, isInPriorityRange)}
                            isInPreloadRange={isInRange(index, isInPreloadRange)}
                            isLive={!isEmpty(addedGifIds) ? includes(addedGifIds, gif.id) : isLive}
                            onSocialClick={onSocialClick}
                            autoPlay={autoPlay}
                        />
                    ))}
                    {isFetching ? <li key="loader" className={css.loader} /> : null}
                </ul>
            </div>
        )
    }
}
